import PropTypes from 'prop-types';
import React, {Suspense, useState} from 'react';
import {connect} from 'react-redux';

import TourDialog from './tour-dialog.jsx';
import {startTour} from '@explorer/actions/tour';
import {hideModal} from '@explorer/actions/ui';
import {trackEvent} from '@explorer/analytics';
import {MODALS, TOUR_DIALOG_KEY} from '@explorer/constants';
import {get as getStored, set as setStored} from '@explorer/util/store';

const ApiDialog = React.lazy(() => import('./api-dialog/index.jsx'));
const DateRangeDialog = React.lazy(
  () => import('./date-range-dialog/index.jsx')
);
const BasemapsNoAccess = React.lazy(() => import('./basemaps-no-access.jsx'));
const OutOfQuota = React.lazy(() => import('./out-of-quota.jsx'));
const SaveDialog = React.lazy(() => import('./save-dialog.jsx'));
const ScenesNoAccess = React.lazy(() => import('./scenes-no-access.jsx'));
const ShareDialog = React.lazy(() => import('./share.jsx'));
const StoriesDialog = React.lazy(() => import('./stories.jsx'));
const SurfaceReflectancePrompt = React.lazy(() => import('./sr-prompt.jsx'));
const OrdersDialog = React.lazy(
  () => import('./orders-dialog/orders-dialog.jsx')
);
const TaskingRedirectDialog = React.lazy(
  () => import('./tasking-redirect.jsx')
);

const ModalsManager = props => {
  const [tourDialogShown, setTourDialogShown] = useState(
    getStored(TOUR_DIALOG_KEY)
  );
  let activeModal;

  const closeModal = () => {
    props.hideModal();
  };

  const closeWelcomeDialog = () => {
    setStored(TOUR_DIALOG_KEY, true);
    setTourDialogShown(true);
    closeModal();
  };

  const onTourSkip = () => {
    trackEvent('Skip Tour button clicked');
    closeWelcomeDialog();
  };

  const onTourStart = () => {
    trackEvent('Start Tour button clicked');
    props.startTour();
    closeWelcomeDialog();
  };

  if (!tourDialogShown) {
    return <TourDialog onTourSkip={onTourSkip} onTourStart={onTourStart} />;
  }

  switch (props.modal) {
    case MODALS.DATE_RANGE:
      activeModal = <DateRangeDialog onClose={closeModal} />;
      break;
    case MODALS.SAVE_SEARCH:
      activeModal = <SaveDialog onClose={closeModal} />;
      break;
    case MODALS.STORIES:
      activeModal = <StoriesDialog onClose={closeModal} />;
      break;
    case MODALS.API:
      activeModal = <ApiDialog onClose={closeModal} />;
      break;
    case MODALS.SCENES_NO_ACCESS:
      activeModal = <ScenesNoAccess onClose={closeModal} />;
      break;
    case MODALS.BASEMAPS_NO_ACCESS:
      activeModal = <BasemapsNoAccess onClose={closeModal} />;
      break;
    case MODALS.ORDER:
      activeModal = <OrdersDialog onClose={closeModal} />;
      break;
    case MODALS.TASKING:
      activeModal = <TaskingRedirectDialog />;
      break;
    case MODALS.SR_PROMPT:
      activeModal = <SurfaceReflectancePrompt onClose={closeModal} />;
      break;
    case MODALS.SHARE:
      activeModal = <ShareDialog onClose={closeModal} />;
      break;
    default:
      activeModal = null;
  }

  return (
    <Suspense>
      <OutOfQuota onClose={closeModal} onDrawClick={props.onDrawClick} />
      {activeModal}
    </Suspense>
  );
};

ModalsManager.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modal: PropTypes.string,
  startTour: PropTypes.func,
  onDrawClick: PropTypes.func,
};

const mapStateToProps = state => ({
  modal: state.ui.modal,
});

const mapDispatchProps = {
  hideModal,
  startTour,
};

export default connect(mapStateToProps, mapDispatchProps)(ModalsManager);
